module.exports = __webpack_public_path__ + "img/add.49083198.svg";